import DomCreator from '../util/DomCreator';
import { rand, konami } from '../functions';
import store from '../util/store';

export default class EasterEggs {
  onSpacebar() {
    this.spacebarPushed = 0;
    window.addEventListener('keyup', (e) => {
      if (e.keyCode == 32) { // spacebar
        this.spacebarPushed += 1;
        if( this.spacebarPushed === 3) {
          let sentences = ['Leeeeeroy Jeeeeenkins', 'Take your time 🙌‍', 'Slow down ! 👮‍♂️🚨', '🐇🐢'];
          const alert = DomCreator.alert(sentences[rand(0, sentences.length - 1)]);
          document.body.appendChild(alert);
          DomCreator.removeAfter(alert, 2);
          this.spacebarPushed = 0;
        }
      } else {
        this.spacebarPushed = 0;
      }
    });
  }

  onKonami() {
    konami( () => {
      // nothing to see here, move along folk
      store.lockBody();
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/animation/EasterEggs.js